import React from 'react';
import './HeaderImage.css';
import { useTranslation } from 'react-i18next';

const HeaderImage = ({ imageSrc, title, description, photographer }) => {
  const { t } = useTranslation();

  return (
    <div className="custom-card">
      <img alt={title} src={imageSrc} className="custom-card-image" />
      <div className="custom-card-content">
        <h1 className='image-card-title'>{title}</h1>
        <p className='image-card-description'>{description}</p>
        
      </div>
      <div className="photographer-info">
          <small className='image-card-photographer'>{t("HEADER_photo_by_label")} {photographer}</small>
        </div>
    </div>
  );
};

export default HeaderImage;
